module.exports = __webpack_public_path__ + "img/default-template-icon.45c7675a.jpg";